import { graphql } from '@/gql';
import type { AvailablePlansForCallerQueryVariables } from '@/gql/graphql';
import { queryExecute } from '@/Utils/graphqlAPI';
import type { CustomizedPlan } from '@/models/plan';

export const getAvailablePlansForCaller = async ({
  phoneNumber,
  callerId,
  type,
}: AvailablePlansForCallerQueryVariables): Promise<CustomizedPlan[]> => {
  const response = await queryExecute({
    query: graphql(`
      query AvailablePlansForCaller($phoneNumber: String, $callerId: String, $type: String) {
        availablePlansForCaller(phoneNumber: $phoneNumber, callerId: $callerId, type: $type) {
          name
          value
          price
          priceNumericCents
          trialPrice
          isTrial
          disabled
          planTier
          type
          kind
          isDefault
          billingCyclePeriodNum
          billingCyclePeriodType
        }
      }
    `),
    variables: {
      phoneNumber,
      callerId,
      type,
    },
    fetchPolicy: 'no-cache',
  });

  return response.data.availablePlansForCaller;
};
